



























import { Result } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      config: CONFIG_GETTERS_KEYS.config,
      components: CONFIG_GETTERS_KEYS.components,
      resultConfig: CONFIG_GETTERS_KEYS.resultsSuggestionsResultConfig
    })
  }
})
export default class ResultsSuggestions extends Vue {
  @Prop({ required: true })
  suggestions: Result[];

  @Prop({ required: true })
  highlightedEmpathizeItem: any;
}
